import React from "react";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { hasPermission } from "./checkPermission";
import PropTypes from "prop-types";

const Can = ({ accessModule, accessCode, accessType, children }) => {
  const { permissions } = useSelector(loggedInUser);

  const __can = hasPermission(
    permissions,
    accessModule,
    accessCode,
    accessType
  );

  return __can ? children : null;
};

Can.propTypes = {
  accessModule: PropTypes.string.isRequired,
  accessType: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  accessCode: PropTypes.string.isRequired,
};

export default Can;
